import { PropsWithChildren } from 'react';

import { sidebarSectionLabelSx } from './sidebarStyles';

import { Typography } from '@cast/design-system';

export const SidebarSection = ({ children }: PropsWithChildren) => (
  <Typography variant="P12B" component="div" sx={sidebarSectionLabelSx}>
    {children}
  </Typography>
);
